import {
  PlaceInfoResType,
  PlaceListResType,
  SavePlaceReqType,
  UpdateBizItemResType,
  ScheduleResType,
} from '@src/types/place';
import client from './client';
import { AxiosResType } from '@src/types/common';
import { RequestBookingListType, RequestBookingScheduleType, RequestBookingType } from '@src/types/booking';

const placeApi = {
  getPlaceInfo: async (url: string, cookie: string) => {
    const { data } = await client.get<PlaceInfoResType>('place/info', { params: { url, cookie } });
    return data;
  },
  getList: async () => {
    const { data } = await client.get<PlaceListResType>('place/list');
    return data;
  },
  saveBookingPlace: async (params: SavePlaceReqType) => {
    const { data } = await client.post<AxiosResType<null>>('place/info', params);
    return data;
  },
  getBizItemsList: async (biz_id: string) => {
    const { data } = await client.get<UpdateBizItemResType>('place/items', { params: { biz_id } });
    return data;
  },
  updateBizItems: async (biz_id: string) => {
    const { data } = await client.post<UpdateBizItemResType>('place/items', {}, { params: { biz_id } });
    return data;
  },
  updateBizSchedule: async (type_id: number, biz_id: string, item_ids: string[]) => {
    const { data } = await client.post('place/items/schedule', {}, { params: { biz_id, type_id, item_ids } });
    return data;
  },
  getScheduleDate: async (item_id: string) => {
    const { data } = await client.get<AxiosResType<{ start_date: string; end_date: string }>>(
      `place/items/schedule/date/${item_id}`,
    );
    return data;
  },
  getScheduleList: async (item_id: string, date: string) => {
    const { data } = await client.get<ScheduleResType>('place/items/schedule', {
      params: { item_id, date },
    });
    return data;
  },
  requestBooking: async (body: RequestBookingType) => {
    const { data } = await client.post<AxiosResType<undefined>>('place/request/booking', {
      ...body,
    });
    return data;
  },
  getRequestList: async () => {
    const { data } = await client.get<AxiosResType<RequestBookingListType[]>>('place/request/booking');
    return data;
  },
  getAdminRequestList: async () => {
    const { data } = await client.get<AxiosResType<RequestBookingListType[]>>('place/request/booking/admin');
    return data;
  },
  confirmAdminRequestList: async (id_list: number[], state: 0 | 1 | 2) => {
    const { data } = await client.put<AxiosResType<RequestBookingListType[]>>('place/request/booking/admin', {
      id_list,
      state,
    });
    return data;
  },
  setCookie: async (id_list: number[], cookie: string) => {
    const { data } = await client.put<AxiosResType<RequestBookingListType[]>>('place/request/booking/cookie', {
      id_list,
      cookie,
    });
    return data;
  },
  getServerTime: async () => {
    const { data } = await client.get<AxiosResType<{ now: number; naver: string; diff: any }>>('server-time');
    return data;
  },
  getTodayBookingRequestList: async () => {
    const { data } = await client.get<AxiosResType<RequestBookingListType[]>>('booking/request/today');
    return data;
  },
  getClubSchdule: async (year: number, month: number) => {
    const { data } = await client.get<AxiosResType<RequestBookingScheduleType[]>>('schedule/club', {
      params: { month, year },
    });
    return data;
  },
  deleteRequest: async (deleteIds: number[]) => {
    const { data } = await client.delete<AxiosResType<undefined>>('place/request/booking', {
      params: { delete_ids: deleteIds },
    });
    return data;
  },
};

export default placeApi;
